import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function NotificationOffIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M12.5025 1.3335L15.6225 3.41357L14.1804 4.85564L12.5025 3.73681L8.93466 6.11523C7.77646 6.8872 7.05674 8.17969 7.00986 9.57324L6.9468 12.0893L4.8733 14.1628C4.8948 14.0168 4.90586 13.868 4.90586 13.7173L5.01084 9.51466C5.07968 7.46925 6.13193 5.5796 7.82529 4.45118L12.5025 1.3335Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M19.8829 17.5351L7.15777 17.5352L5.15776 19.5352H10.173C10.1883 20.8123 11.2215 21.8392 12.5022 21.8392C13.783 21.8392 14.8163 20.8123 14.8316 19.5352H22.9825V16.8784L22.295 16.6523C21.0094 16.229 20.1451 15.0493 20.1446 13.6865L20.0143 9.47169C19.9608 8.18193 19.5108 6.95132 18.7539 5.93902L17.319 7.37389C17.7367 8.01655 17.9832 8.76605 18.0157 9.54394L18.1451 13.7173C18.1451 15.2119 18.8004 16.5889 19.8829 17.5351Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M2.20134 16.8347L2.06846 16.9676V16.8784L2.20134 16.8347Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M19.718 3.76529L18.3038 2.35107L1.33325 19.3216L2.74747 20.7359L19.718 3.76529Z",
    fill: "currentColor"
  }));
}